import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Form, Message } from 'semantic-ui-react';
import { useRecaptcha } from '../../../components/RecaptchaProvider/RecaptchaProvider.hooks';
import './FooterEmailCapture.css';
var defaultProps = {
  isSuccess: false,
  formFieldValues: {},
  isSubmitting: false
};
export default function FooterEmailCapture(_ref) {
  var submitForm = _ref.submitForm,
    updateFormFields = _ref.updateFormFields,
    formFieldValues = _ref.formFieldValues,
    isSuccess = _ref.isSuccess,
    isSubmitting = _ref.isSubmitting;
  var _useRecaptcha = useRecaptcha(),
    _useRecaptcha2 = _slicedToArray(_useRecaptcha, 2),
    recaptchaLoaded = _useRecaptcha2[1];
  var id = 'footer-email-capture-email-input';
  return /*#__PURE__*/React.createElement(Form, {
    size: "tiny",
    onSubmit: submitForm,
    success: isSuccess
  }, /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, "Subscribe For Updates"), /*#__PURE__*/React.createElement(Form.Input, {
    action: {
      primary: true,
      icon: 'send',
      type: 'submit',
      'aria-label': 'Subscribe for updates'
    },
    id: id,
    onChange: function onChange(e) {
      return updateFormFields('email', e);
    },
    placeholder: "Your Email",
    required: true,
    type: "email",
    value: formFieldValues.email,
    disabled: isSubmitting || !recaptchaLoaded
  })), /*#__PURE__*/React.createElement(Message, {
    success: true,
    header: "Subscribed!"
  }));
}
FooterEmailCapture.defaultProps = defaultProps;